import { useState } from 'react';
import { faqs } from '@/mocks/gossip';
import SectionHead from './SectionHead';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-28 py-12 md:py-16 bg-background-100/60">
      <div className="mx-auto max-w-[1100px] px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <SectionHead
            kicker="FAQ"
            kickerZh="常见问题"
            title="关于吃瓜热点，你可能想问"
            desc="从网站定位、栏目逻辑到信息核实口径，我们把最常见的问题一次性讲清楚。"
          />
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? 'border-primary-300 bg-background-50' : 'border-background-200 bg-background-50/70'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-accent-100 text-accent-700'
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="text-sm md:text-base font-semibold text-foreground-950">{f.q}</span>
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                      isOpen ? 'rotate-45 text-primary-600' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[68px] text-sm leading-7 text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}